import { ProjectedRateDto } from '@zorro/clients';

import { PlanBadge } from '../PlanBadge';
import {
  PROJECTED_RATE_LABEL,
  getProjectedRateTooltipLabel,
} from './projectedRateTooltip';

type Props = {
  projectedRate?: ProjectedRateDto | null;
  stateCode?: string | null;
  size?: 'xs' | 'sm' | 'md';
};

export const ProjectedRateBadge = ({
  projectedRate,
  stateCode,
  size = 'sm',
}: Props) => {
  if (!projectedRate) {
    return null;
  }

  return (
    <PlanBadge
      color="indigo"
      tooltipLabel={getProjectedRateTooltipLabel(projectedRate, stateCode)}
      label={PROJECTED_RATE_LABEL}
      size={size}
    />
  );
};
